import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {OnboardingView} from "../components/onboarding/OnboardingView";

const Download: NextPage = () => {
  return <>
    <Head>
      <title>Start Your Plan</title>
    </Head>
    <OnboardingView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'macro_plan']),
    }
  }
});

export default Download